import React from "react";

import Shell from 'components/layout/list/shell';
import Errors from 'components/error404';
import { TireRoutes } from 'components/tire/routes';
import SignIn from 'signin';
import HomeMain from "home";
import Privacy from "components/privacy";
import Terms from "components/terms";
import PaymentMain from "components/subscription";

export function LogoutRoutes() {
    return [
        {
            path: '',
            element: (<HomeMain />),
            errorElement: <HomeMain />
        },
        {
            path: '/signIn',
            element: (<SignIn />),
            errorElement: <SignIn />
        },
        {
            path: '/privacy',
            element: (<Privacy />),
            errorElement: <Privacy />
        },
        {
            path: '/payment',
            element: (<PaymentMain />),
            errorElement: <PaymentMain />
        },
        {
            path: '/terms',
            element: (<Terms />),
            errorElement: <Terms />
        },
        {
            path: '/tire',
            element: (<Shell />),
            errorElement: <Errors />,
            children: TireRoutes()
        },
        {
            path: '*',
            element: (<HomeMain />),
            errorElement: <HomeMain />
        },


    ]
}

export default LogoutRoutes;